export const DOMAIN_WHITELIST = [
  'netlync.com',
  'mailinator.com',
];

export const DOMAIN_WHITELIST_REGEX = new RegExp(
  `@(${DOMAIN_WHITELIST.join('|')})$`,
);
